export const GUARD_ROUTES = {
  MAESTRO_ACCOUNT_LIST_PAGE: { name: "Maestro/AccountList" },
  ORGANIZATION_ACCOUNT_LIST_PAGE: { name: "Maestro/OrganizationAccountList" },
  COMPANY_LIST_PAGE: { name: "OtaManagement/CompanyList" },
  EMERGENCY_STOP_PAGE: { name: "OtaManagement/EmergencyStop" },
  INVENTORY_PAGE: { name: "InventoryManagement" },
  SHARED_INVENTORY_PAGE: { name: "SharedInventoryManagement" },
  FORBIDDEN_PAGE: { name: "Forbidden" },
  SIGN_IN_PAGE: { name: "SignIn", replace: true }
}
